'use client'

import React from 'react'

import {sanitizeHtml} from '@/src/shared/utils/functions'

import * as UI from './product-detail.styled'

interface IProps {
  description: string
  className?: string
  limited?: boolean
}

const ProductDescription = ({description, className}: IProps) => {
  if (!description) return null

  return (
    <UI.Description className={className}>
      <UI.DescriptionContainer>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(description),
          }}
        />
      </UI.DescriptionContainer>
    </UI.Description>
  )
}

export default ProductDescription
